// 满意度选择列表
export const notChooseList: string[] = [
    'https://simg01.gaodunwangxiao.com/uploadfiles/files/202409/26/77434_20240926110006.png',
    'https://simg01.gaodunwangxiao.com/uploadfiles/files/202409/26/f1ad4_20240926105852.png',
    'https://simg01.gaodunwangxiao.com/uploadfiles/files/202409/26/385c2_20240926105750.png',
    'https://simg01.gaodunwangxiao.com/uploadfiles/files/202409/26/22dc1_20240926105700.png',
    'https://simg01.gaodunwangxiao.com/uploadfiles/files/202409/26/b3762_20240926105544.png',
];

// 满意列表
export const satisfiedList: string[] = [
    'http://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202403/11/323a6_20240311143853.png',
    'http://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202403/11/f6ea4_20240311143954.png',
    'http://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202403/11/9dc44_20240311144019.png',
    'http://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202403/11/a7d1f_20240311144520.png',
    'http://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202403/11/dd873_20240311144545.png',
];

export const commentDesc = ['非常不满意', '不满意', '不太满意', '满意', '非常满意'];